import { useEffect, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import ModalRegistro from "./ModalRegistro";
import MenuDigital from "./Clientes";
import { API_BASE_URL } from "../../config";

const RestauranteMenu = () => {
  const { cliente_id } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // ✅ Definir correctamente `searchParams`
  const [mostrarRegistro, setMostrarRegistro] = useState(false);
  const [usuarioAutenticado, setUsuarioAutenticado] = useState(false);
  const [localClienteId, setClienteId] = useState(cliente_id || null); // ✅ Se define correctamente `setClienteId`
  const usuarioId = localStorage.getItem("usuario_id");

  useEffect(() => {
    console.log("🔍 [RestauranteMenu.js] Verificando cliente_id...");

    const token = localStorage.getItem("token");
    const usuarioId = localStorage.getItem("usuario_id");
    const storedClienteId = localStorage.getItem("cliente_id");
    const urlClienteId = searchParams.get("menu");

    console.log("📌 Estado cliente_id:", localClienteId);
    console.log("📌 LocalStorage cliente_id:", storedClienteId);
    console.log("📌 URL cliente_id:", urlClienteId);

    // ✅ Usuario autenticado si tiene token y usuarioId
    setUsuarioAutenticado(!!(token && usuarioId));

    // 🛑 Si `cliente_id` ya está definido y coincide, evitamos la consulta innecesaria
    if (localClienteId && (localClienteId === urlClienteId || localClienteId === storedClienteId)) {
      console.log("✅ [RestauranteMenu.js] cliente_id ya definido correctamente.");
      return;
    }

    // 🚀 Si cliente_id no está en URL ni localStorage, lo obtenemos de la API
    if (token && usuarioId) {
      fetch(`${API_BASE_URL}/usuario/menu?usuario_id=${usuarioId}`)
        .then(res => res.json())
        .then(data => {
          if (data.cliente_id) {
            const newClienteId = data.cliente_id.toString();

            if (newClienteId !== localClienteId) {
              console.log("🔄 [RestauranteMenu.js] Redirigiendo a:", `/usuario/${usuarioId}?menu=${newClienteId}`);
              setClienteId(newClienteId);
              localStorage.setItem("cliente_id", newClienteId);
              navigate(`/usuario/${usuarioId}?menu=${newClienteId}`);
            }
          } else {
            console.error("❌ [RestauranteMenu.js] No se encontró cliente_id en la API.");
            setUsuarioAutenticado(true);
          }
        })
        .catch(() => {
          console.error("❌ [RestauranteMenu.js] Error al obtener cliente_id.");
          setUsuarioAutenticado(true);
        });
    } else {
      console.warn("⚠️ [RestauranteMenu.js] Usuario no autenticado.");
      setUsuarioAutenticado(false);
    }
  }, [searchParams, localClienteId]); // ✅ Se evitan loops infinitos

  return (
    <div>
      {mostrarRegistro && (
        <ModalRegistro
          closeModal={() => setMostrarRegistro(false)}
          onSuccess={() => {
            const usuarioId = localStorage.getItem("usuario_id");
            const clienteGuardado = localStorage.getItem("cliente_id") || localClienteId;

            console.log("Redirigiendo tras registro:", `/usuario/${usuarioId}?menu=${clienteGuardado}`);

            setTimeout(() => {
              navigate(`/usuario/${usuarioId}?menu=${clienteGuardado}`, { replace: true });
            }, 1500);
          }}
        />
      )}

      <MenuDigital clienteId={localClienteId} />

      {!usuarioAutenticado && (
        <button onClick={() => setMostrarRegistro(true)} className="btn-registro">
          Registrarse para más funciones
        </button>
      )}
    </div>
  );
};

export default RestauranteMenu;
